<template>
    <NavTab class="nav-tabs-highlight">
        <NavTabItem :href="`#lang-alias-${targetLanguage.value}`" :ref="setTabRef" v-for="targetLanguage in targetLanguages">{{ targetLanguage.label }}</NavTabItem>
        <template #content>
            <NavTabPane :id="`lang-alias-${targetLanguage.value}`" v-for="targetLanguage in targetLanguages">
                <div class="row">
                    <div class="col-md-6">
                        <FormGroup :label="`${$t('labels.name')} (${sourceLanguage.label})`" v-if="fieldsForTranslation.includes('names')">
                            <Input :model-value="product.names[sourceLanguage.value]" readonly />
                        </FormGroup>
                        <FormGroup :label="`${$t('labels.description')} (${sourceLanguage.label})`" v-if="fieldsForTranslation.includes('descriptions')">
                            <InputTextArea :model-value="product.descriptions[sourceLanguage.value]" disabled />
                        </FormGroup>
                        <FormGroup :label="`${$t('labels.seo')} (${sourceLanguage.label})`" v-if="fieldsForTranslation.includes('seos')">
                            <Tags :model-value="product.seos[sourceLanguage.value]" disabled />
                        </FormGroup>
                    </div>
                    <div class="col-md-6">
                        <FormGroup :label="`${$t('labels.name')} (${targetLanguage.label})`" v-if="fieldsForTranslation.includes('names')">
                            <Input v-model="resultTranslations.names[targetLanguage.value]" />
                        </FormGroup>
                        <FormGroup :label="`${$t('labels.description')} (${targetLanguage.label})`" v-if="fieldsForTranslation.includes('descriptions')">
                            <InputTextArea v-model="resultTranslations.descriptions[targetLanguage.value]" />
                        </FormGroup>
                        <FormGroup :label="`${$t('labels.seo')} (${targetLanguage.label})`" v-if="fieldsForTranslation.includes('seos')">
                            <Tags v-model="resultTranslations.seos[targetLanguage.value]" />
                        </FormGroup>
                    </div>
                </div>
            </NavTabPane>
        </template>
    </NavTab>
</template>
<script>
import NavTab from '../../../../../../components/tabs/NavTab.vue';
import NavTabItem from '../../../../../../components/tabs/NavTabItem.vue';
import NavTabPane from '../../../../../../components/tabs/NavTabPane.vue';
import FormGroup from '../../../../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../../../../components/new/form/Input.vue';
import InputTextArea from '../../../../../../../components/new/form/InputTextArea.vue';
import Tags from '../../../../../../../components/new/form/Tags.vue';

export default {
    name: "ContentTranslationResultView",
    components: {
        NavTab, NavTabItem, NavTabPane, FormGroup, Input, InputTextArea, Tags
    },
    props: {
        product: {
            type: Object,
            required: true
        },
        targetLanguages: {
            type: Array,
            default: () => []
        },
        fieldsForTranslation: {
            type: Array,
            default: () => []
        },
        resultTranslations: {
            type: Object,
            default: null
        },
        sourceLanguage: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            tabRefs: [],
        }
    },
    methods: {
        setTabRef(el) {
            if (el) {
                this.tabRefs.push(el);
            }
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.tabRefs[0].click()
        });
    }
}
</script>